// When adding a dimension with an irregular plural (e.g. community → communities),
// also update TABLE_NAMES in sb-backend/utils/DimensionAnalytics.js
export const DIMENSIONS = [
    { value: 'location', label: 'Location', plural: 'locations', itemLabel: 'Store' },
    { value: 'source', label: 'Source', plural: 'sources', itemLabel: 'Source' },
    { value: 'community', label: 'Community', plural: 'communities', itemLabel: 'Community' },
];
